import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, min, max, min_value as minValue, max_value as maxValue, } from 'vee-validate/dist/rules';
const veeValidatePlugin = (ctx) => {
    Vue.component('ValidationProvider', ValidationProvider);
    Vue.component('ValidationObserver', ValidationObserver);
    extend('required', {
        ...required,
        message: () => ctx.i18n.t(`validation.rules.required`),
    });
    extend('email', {
        ...email,
        message: () => ctx.i18n.t(`validation.rules.email`),
    });
    extend('min', {
        ...min,
        message: (_, { length }) => ctx.i18n.t(`validation.rules.min`, { length }),
    });
    extend('max', {
        ...max,
        message: (_, { length }) => ctx.i18n.t(`validation.rules.max`, { length }),
    });
    extend('min_value', {
        ...minValue,
        message: (_, { min }) => ctx.i18n.t(`validation.rules.min_value`, { min }),
    });
    extend('max_value', {
        ...maxValue,
        message: (_, { max }) => ctx.i18n.t(`validation.rules.max_value`, { max }),
    });
    extend('zipcode', {
        validate: (value) => {
            if (typeof value !== 'string')
                return false;
            return /^[0-9]{5}$/.test(value);
        },
        message: () => ctx.i18n.t('validation.rules.zipcode'),
    });
    extend('case_number', {
        validate: (value) => {
            if (typeof value !== 'string')
                return false;
            return /^[A-Za-z0-9\-._~()'!*:@,;]+$/.test(value);
        },
        message: () => ctx.i18n.t('validation.rules.case_number'),
    });
};
export default veeValidatePlugin;
